import React, { useState } from "react";
import Select from "react-select";
import { States } from "./States";
import { FaWarehouse, FaTimes } from "react-icons/fa";
import { BsTelephoneFill } from "react-icons/bs";
import { MdLocationOn } from "react-icons/md";

export const Warehouse = ({ warehouseInfo, accounts = [], onSave, onClose }) => {
  const [name, setName] = useState(warehouseInfo?.name || "");
  const [contactName, setContactName] = useState(
    warehouseInfo?.emails?.[0]?.name || warehouseInfo?.contact_name || ""
  );
  const [contactEmail, setContactEmail] = useState(
    warehouseInfo?.emails?.[0]?.email || ""
  );
  const [phone, setPhone] = useState(warehouseInfo?.phone || "");
  const [address, setAddress] = useState(warehouseInfo?.address || "");
  const [city, setCity] = useState(warehouseInfo?.city || "");
  const [state, setState] = useState(warehouseInfo?.state || "");
  const [zip, setZip] = useState(warehouseInfo?.zip || "");
  const [selectedAccounts, setSelectedAccounts] = useState(
    warehouseInfo?.accounts || accounts.map((a) => (typeof a === "object" ? a.account_no : a))
  );

  const [nameError, setNameError] = useState("");

  const stateOptions = States.map((st) => ({
    value: st?.abbreviation,
    label: st?.abbreviation,
  })).sort((a, b) => (a.label || "").localeCompare(b.label || ""));

  const handleSubmit = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (!name.trim()) {
      setNameError("Name cannot be empty");
      return;
    }

    const updatedWarehouse = {
      ...warehouseInfo,
      name,
      phone,
      address,
      city,
      state,
      zip,
      accounts: selectedAccounts,
      emails: [
        {
          name: contactName,
          email: contactEmail,
        },
      ],
    };

    onSave(updatedWarehouse);
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-content warehouse-modal">
        <div className="modal-header">
          <h3>{warehouseInfo?.name ? `Edit ${warehouseInfo.name}` : "New Warehouse"}</h3>
          <button type="button" className="close-btn" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        <div className="warehouse-modal-form">
          <div className="form-group">
            <label>Warehouse Name</label>
            <div className="input-with-icon">
              <FaWarehouse className="input-icon" />
              <input
                type="text"
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                  if (e.target.value.trim()) setNameError("");
                }}
                placeholder="Warehouse Name"
              />
            </div>
            {nameError && <p className="error-text">{nameError}</p>}
          </div>

          <div className="form-row">
            <div className="form-group half">
              <label>Contact Name</label>
              <div className="input-with-icon">
                <FaWarehouse className="input-icon" />
                <input
                  type="text"
                  value={contactName}
                  onChange={(e) => setContactName(e.target.value)}
                  placeholder="Contact Name"
                />
              </div>
            </div>

            <div className="form-group half">
              <label>Phone Number</label>
              <div className="input-with-icon">
                <BsTelephoneFill className="input-icon" />
                <input
                  type="text"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  placeholder="Phone Number"
                />
              </div>
            </div>
          </div>

          <div className="form-group">
            <label>Street Address</label>
            <div className="input-with-icon">
              <MdLocationOn className="input-icon" />
              <input
                type="text"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                placeholder="Street Address"
              />
            </div>
          </div>

          <div className="form-row address-row">
            <div className="form-group flex-2">
              <label>City</label>
              <input
                type="text"
                value={city}
                onChange={(e) => setCity(e.target.value)}
                placeholder="City"
                className="simple-input"
              />
            </div>

            <div className="form-group flex-1">
              <label>State</label>
              <Select
                options={stateOptions}
                onChange={(e) => setState(e ? e.value : "")}
                value={state ? { value: state, label: state } : null}
                className="state-select-container"
                classNamePrefix="select"
              />
            </div>

            <div className="form-group flex-1">
              <label>ZIP</label>
              <input
                type="text"
                value={zip}
                onChange={(e) => setZip(e.target.value)}
                placeholder="ZIP"
                className="simple-input"
              />
            </div>
          </div>

          <div className="modal-actions">
            <button type="button" className="cancel-btn" onClick={onClose}>
              Cancel
            </button>
            <button type="button" className="save-btn" onClick={handleSubmit}>
              Save Warehouse
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Warehouse;
